import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  AfterViewChecked,
  AfterViewInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
//import { IUser } from '../../../shared/interfaces/IUser';
import { Subject } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { LandingService } from '../../services/landing.service';
import { takeUntil } from 'rxjs/operators';
import { SessionService } from '../../../core/services/session.service';
import { AuthService } from '../../../auth/services/auth.service';
import { IClient } from '../../../shared/interfaces/IClient';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IProduct } from '../../../shared/interfaces/IProduct';
import * as landingSelector from '../../store/selectors/landing.selectors';
import { DomSanitizer } from '@angular/platform-browser';
import * as fromLanding from '../../store/actions/landing.actions';
import {
  ActivatedRoute,
  Router,
  NavigationEnd,
  NavigationStart,
} from '@angular/router';
import { IPeriodicity } from '../../../shared/interfaces/IPeriodicity';
//import { IPeriodicityPivot } from '../../../shared/interfaces/IPeriodicityPivot';
//import { IClientPaymentMethod } from '../../../shared/interfaces/IClientPaymentMethod';
import { getUser } from '../../../core/store/actions/core.actions';
//import { trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-purchase-page',
  templateUrl: './purchase-page.component.html',
  styleUrls: ['./purchase-page.component.scss'],
})
export class PurchasePageComponent
  implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit
{
  title = 'angular-maps';
  @ViewChild('placesRef') placesRef: GooglePlaceDirective;
  options = {
    types: [],
    componentRestrictions: { country: 'AR' },
  };
  visible: boolean = true;
  changeType: boolean = true;
  userData: any;
  viewMap: boolean = false;
  sameAddressForBilling: boolean = true;
  lat: number;
  lon: number;
  zoom;
  sameAddressAsInstallation: boolean = true;
  map: google.maps.Map;
  marker: google.maps.Marker;
  street: string;
  street_number: string;
  city: string;
  province: string;
  department: string;
  isLogged: boolean;
  user: IClient;
  bill_addresses: any;
  product: IProduct;
  destroy$: Subject<any>;
  step = 1;
  bill_street: string;
  bill_street_number: string;
  bill_department: string;
  bill_province: string;
  bill_city: string;
  bill_floor: string;
  bill_postal_code: string;
  mode = 'register';
  errors: any;
  zip_code: number;
  tipoExperiencia: string = '';
  zipCode: string = '';
  loading = false;
  person_type: '';
  metWays: any[] = [];
  plan;
  periodicity: IPeriodicity;
  total = 0;
  quantity: string = '';
  type: string;
  detailText: string;
  serviceText: string;
  serviceName: string;
  updateDataType: string;

  // Mercado Pago properties - solo para checkout links
  paymentMethods: any[] = [];
  isPaymentMethodDisabled: boolean = false;

  // Estados de error y timeout
  paymentError: string = ''; // Mensaje de error específico
  hasPaymentError: boolean = false; // Indica si hay un error de pago
  checkoutUrl: string = ''; // URL del checkout de Mercado Pago
  isRedirecting: boolean = false; // Indica si se está redirigiendo al checkout

  // Validación de código postal
  isValidatingZipCode: boolean = false;
  zipCodeError: string = '';
  isZipCodeValid: boolean = false;

  registerForm = this.formBuilder.group({
    full_name: ['', [Validators.required]],
    email: ['', [Validators.required]],
    gender: [''],
    iva_exempt: [false, [Validators.required]],
    phone: ['', [Validators.required]],
    document: ['', [Validators.required, lengthValidator(7, 11)]],
    met_way_id: [''],
    codigo_descuento: [''],
    iva_condition: [''],
    payment_condition: [''],
  });
  loginForm = this.formBuilder.group({
    email: ['', [Validators.required]],
    password: ['', [Validators.required]],
  });
  stepOneForm = this.formBuilder.group({
    street: ['', [Validators.required]],
    street_number: ['', [Validators.required]],
    department: [''],
    province: ['', [Validators.required]],
    city: ['', [Validators.required]],
    lat: [''],
    lon: [''],
    floor: [''],
    postal_code: ['', [Validators.required]],
    install_date: [''],
    observations: [''],
    codigo_descuento: [''],
    bill_street: [''],
    bill_street_number: [''],
    bill_department: [''],
    bill_province: [''],
    bill_city: [''],
    bill_floor: [''],
    bill_postal_code: [''],
    sameAddressAsInstallation: [true],
  });
  stepTwoForm = this.formBuilder.group({
    street: ['', [Validators.required]],
    street_number: ['', [Validators.required]],
    department: [''],
    province: ['', [Validators.required]],
    city: ['', [Validators.required]],
    lat: [''],
    lon: [''],
    floor: [''],
    postal_code: ['', [Validators.required]],
    install_date: [''],
    observations: [''],
    payment_method: ['', [Validators.required]],
    codigo_descuento: [''],
    quantity: this.quantity,
    sameAddressAsInstallation: [true],
    bill_street: [''],
    bill_street_number: [''],
    bill_department: [''],
    bill_province: [''],
    bill_city: [''],
    bill_floor: [''],
    bill_postal_code: [''],
  });
  genders = ['Masculino', 'Femenino', 'No definido'];
  checkVeraz: boolean = null;
  veraz_score: any = null;
  isSubsText: string;
  private previousUrl: string | null = null;
  private beforePreviousUrl: string | null = null; // Aquí guardamos la penúltima URL
  constructor(
    private store: Store<AppState>,
    private formBuilder: FormBuilder,
    private landingService: LandingService,
    private sessionService: SessionService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private _sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private location: Location,
    private http: HttpClient,
    private router: Router,
  ) {
    this.destroy$ = new Subject<any>();
  }
  empresaSelect: boolean = false;

  updateUserForm = this.formBuilder.group({
    first_name: ['', [Validators.required]],
    last_name: [''],
    email: [{ value: '', disabled: true }, [Validators.required]], // Email deshabilitado
    gender: [''],
    iva_exempt: [false, [Validators.required]],
    password: [''],
    password_confirmation: [''],
    phone: ['', [Validators.required]],
    document: ['', [Validators.required]],
    met_way_id: [''],
    person_type: [''],
    codigo_descuento: [''],
  });
  onContinueClick(event: Event): void {
    //event.preventDefault();
    this.viewMap = false;
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  isDateInRange: boolean = false;
  ngOnInit(): void {
    /*this.route.queryParams.subscribe(params => {
        this.zipCode = params['zipCode'];
      });*/

    // CYBERFIL 2024
    this.gotoTop();
    const today = new Date();
    const startDate = new Date('2024-10-30');
    const endDate = new Date('2024-11-10');
    endDate.setHours(23, 59, 59, 999); // Incluye todo el día 10
    this.isDateInRange = today >= startDate && today <= endDate;
    // END CYBERFIL 2024

    this.store.select('core').subscribe((res) => {
      this.isLogged = res.isLogged && !res.isLoading;
      this.user = res.user;

      if (this.user && this.user.name) {
        const names = this.user.name.split(',');
        const lastName = names[0].trim();
        const firstName = names.length > 1 ? names[1].trim() : '';

        this.empresaSelect = this.user.person_type === 'EMPRESA';
        this.updateUserForm.patchValue({
          person_type: this.empresaSelect ? 'before' : 'after',
        });

        if (this.empresaSelect) {
          this.updateUserForm.patchValue({
            first_name: this.user.name,
          });
        } else {
          this.updateUserForm.patchValue({
            first_name: firstName,
          });
        }

        // this.empresaSelect = this.user.person_type !== 'PERSONA FISICA';

        // Actualizar los valores del formulario con los datos del usuario
        this.updateUserForm.patchValue({
          last_name: lastName,
          document: this.user.document,
          phone: this.user.phone,
          gender: this.user.gender,
          email: this.user.email,
        });
        const fullAddress = this.user?.addresses[0]?.address;

        const match = fullAddress?.match(
          /^(.+?)\s+(\d{1,5}(?:\s?[A-Za-z]{0,4})?)$/,
        );

        if (match) {
          this.street = match[1].trim(); // "Av. Santa Fe"
          this.street_number = match[2].trim(); // "2345 Bis"
        }
        this.stepTwoForm.patchValue({
          street: this.street,
          street_number: this.street_number,
          province: this.user?.addresses[0]?.city,
          city: this.user?.addresses[0]?.city,
          postal_code: this.user?.addresses[0]?.postal_code,
          floor: this.user?.addresses[0]?.floor,
          department: this.user?.addresses[0]?.department,
        });

        // Validar automáticamente el código postal del usuario si existe
        if (this.user?.addresses[0]?.postal_code) {
          this.validateInstallationZipCode(
            this.user.addresses[0].postal_code.toString(),
          );
        }
      }
    });

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        if (params['zipCode'] && params['zipCode'] != 'null') {
          this.zipCode = params['zipCode'];
          // Validar automáticamente el código postal de la URL
          setTimeout(() => {
            this.validateInstallationZipCode(this.zipCode);
          }, 500);
        }
        if (params['disc']) {
          if (
            params['disc'] == 'CYBERFIL50' ||
            params['disc'] == 'CYBERFIL20'
          ) {
            this.discount = params['disc'];
            this.registerForm.patchValue({
              codigo_descuento: this.discount,
            });
            this.stepOneForm.patchValue({
              codigo_descuento: this.discount,
            });
            this.stepTwoForm.patchValue({
              codigo_descuento: this.discount,
            });
          }
        }
        if (params.plan) {
          this.plan = params.plan;
        } else {
          this.product = null;
        }
        if (params.quantity) {
          this.quantity = params.quantity;
          this.stepTwoForm.patchValue({ quantity: this.quantity });
        }
        if (params.type) {
          this.type = params.type;
          localStorage.setItem('type', this.type);
          // Establecer el valor del payment_method basado en el type
          const paymentMethod =
            this.type === 'sub' ? 'Mercado Pago Sus' : 'Mercado Pago';
          this.stepTwoForm.patchValue({ payment_method: paymentMethod });

          if (this.type === 'sale') {
            this.detailText = 'Detalles de la Venta';
            this.registerForm.patchValue({
              iva_condition: '3',
              payment_condition: 'Contado',
            });
          } else if (this.type === 'sub') {
            this.detailText = 'Detalles de la Suscripción';
            this.serviceText = 'Suscripción: ';
          }

          // Configurar métodos de pago después de establecer el tipo
          this.setupPaymentMethods();
        }

        this.store.dispatch(
          fromLanding.getProduct({
            id: params.product,
            zipCode: this.zip_code,
            periodicity: this.plan,
          }),
        );
      });
    this.store
      .select(landingSelector.selectProductDetail)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.product = JSON.parse(JSON.stringify(res));
        if (this.product) {
          this.product.imageUrl = this.product?.galeries[0]?.file_name;
          this.periodicity = this.product.periodicity
            ? this.product.periodicity[0]
            : null;
          this.total =
            parseFloat(this.periodicity.pivot.price.toString()) +
            parseFloat(this.periodicity.pivot.periodic_price.toString());
        }
      });

    // Suscribirse a los cambios del cupón de descuento
    this.store
      .select(landingSelector.selectCouponDiscount)
      .pipe(takeUntil(this.destroy$))
      .subscribe((discount) => {
        this.couponDiscount = discount;
        this.isCouponValid = !!discount;

        // Guardar en localStorage cuando hay un descuento válido
        if (discount) {
          localStorage.setItem(
            'appliedCoupon',
            JSON.stringify({
              code: this.couponCode,
              discount: discount,
            }),
          );
        }
      });

    this.store
      .select(landingSelector.selectCouponProducts)
      .pipe(takeUntil(this.destroy$))
      .subscribe((products) => {
        if (products && products.length > 0) {
          this.couponProducts = products;
          this.updateProductWithDiscount();
        }
      });

    this.store
      .select(landingSelector.selectCouponError)
      .pipe(takeUntil(this.destroy$))
      .subscribe((error) => {
        if (error) {
          this.couponError = error.error?.message || 'El cupón no es válido';
          this.isCouponValid = false;
        } else {
          this.couponError = '';
        }
      });

    this.store
      .select(landingSelector.selectCouponLoading)
      .pipe(takeUntil(this.destroy$))
      .subscribe((loading) => {
        this.couponLoading = loading;
      });

    // Cargar cupón guardado del localStorage
    this.loadSavedCoupon();

    this.store.select('core').subscribe((res) => {
      this.isLogged = res.isLogged && !res.isLoading;
      this.user = res.user;

      if (this.user && this.user.addresses) {
        var ckec = this.user.addresses.find((element) => {
          if (element.pivot.client_id == this.user.id) {
            return true;
          }
          return false;
        });
        // var numero = ckec.address.split(' ');
        // var direccion = ckec.address;
        // var lastIndex = direccion.lastIndexOf(" ");
        var numero = null;
        var direccion = null;

        if (ckec && ckec.address && ckec.address != 'Sin Direcciones') {
          numero = ckec.address.split(' ');
          direccion = ckec.address;
          var lastIndex = direccion.lastIndexOf(' ');
          direccion = direccion.substring(0, lastIndex);
          this.stepOneForm.controls['department'].setValue(ckec.department);
          this.stepOneForm.controls['province'].setValue(ckec.province);
          this.stepOneForm.controls['city'].setValue(ckec.city);
          this.stepOneForm.controls['floor'].setValue(ckec.floor);
          this.stepOneForm.controls['postal_code'].setValue(ckec.postal_code);
          this.stepOneForm.controls['street'].setValue(direccion);
          if (numero && numero.length > 0) {
            this.stepOneForm.controls['street_number'].setValue(
              numero[numero.length - 1],
            );
          }

          // Validar automáticamente el código postal si existe
          if (ckec.postal_code) {
            setTimeout(() => {
              this.validateInstallationZipCode(ckec.postal_code.toString());
            }, 500);
          }

          // Cargar también el floor en stepTwoForm si existe
          if (ckec.floor) {
            this.stepTwoForm.patchValue({
              floor: ckec.floor,
            });
          }
        }
      }

      if (this.isLogged) {
        this.step = 2;
        // Verificar automáticamente si necesita configurar dirección
        setTimeout(() => {
          this.checkAndRedirectToAddress();
        }, 100);
      }
    });

    this.landingService
      .getMetWays()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.metWays = res;
      });

    if (!this.stepOneForm.contains('sameAddressAsInstallation')) {
      this.stepOneForm.addControl(
        'sameAddressAsInstallation',
        this.formBuilder.control(this.sameAddressForBilling),
      );
    }

    this.stepOneForm
      .get('sameAddressAsInstallation')
      .valueChanges.subscribe((value) => {
        if (value) {
          this.copyInstallationAddressToBilling();
        } else {
          this.clearBillingAddress();
        }
      });

    // Sincronizar facturación con dirección en stepTwoForm también
    this.stepTwoForm
      .get('sameAddressAsInstallation')
      .valueChanges.subscribe((value) => {
        if (value) {
          this.copyStepTwoAddressToBilling();
        }
      });
    // Copia inicial al cargar si está marcado
    if (this.stepTwoForm.get('sameAddressAsInstallation')?.value) {
      this.copyStepTwoAddressToBilling();
    }
  }
  goBack(): void {
    let type = localStorage.getItem('type');
    console.log('type outside sessionStorage:', type);
    this.router.navigateByUrl(
      `/products/${this.product.id}?type=${encodeURIComponent(type)}`,
    );
    localStorage.clear();
  }

  copyInstallationAddressToBilling(): void {
    if (!this.stepOneForm) return;
    const src = this.stepOneForm.value;
    const billing = {
      bill_street: src.street,
      bill_street_number: src.street_number,
      bill_department: src.department,
      bill_province: src.province,
      bill_city: src.city,
      bill_floor: src.floor,
      bill_postal_code: src.postal_code,
    };
    // Completar facturación en stepOneForm (donde se muestra la sección)
    this.stepOneForm.patchValue(billing);
    // Mantener sincronizado también stepTwoForm
    this.stepTwoForm.patchValue(billing);
  }

  clearBillingAddress(): void {
    const empty = {
      bill_street: '',
      bill_street_number: '',
      bill_department: '',
      bill_province: '',
      bill_city: '',
      bill_floor: '',
      bill_postal_code: '',
    };
    // Limpiar en ambos formularios para consistencia
    this.stepOneForm.patchValue(empty);
    this.stepTwoForm.patchValue(empty);
  }

  private copyStepTwoAddressToBilling(): void {
    if (!this.stepTwoForm) return;
    const src = this.stepTwoForm.value;
    this.stepTwoForm.patchValue({
      bill_street: src.street,
      bill_street_number: src.street_number,
      bill_department: src.department,
      bill_province: src.province,
      bill_city: src.city,
      bill_floor: src.floor,
      bill_postal_code: src.postal_code,
    });
  }

  public handleAddressChange(address: Address) {
    this.viewMap = true;

    // Resetear estado de validación de código postal
    this.isValidatingZipCode = false;
    this.zipCodeError = '';
    this.isZipCodeValid = false;

    //console.log(address);

    const mapDiv = document.getElementById('map');
    if (!mapDiv) {
      console.error('Elemento del mapa no encontrado');
      return;
    }

    const mapOptions = {
      center: { lat: -34.61, lng: -58.38 },
      zoom: 15,
    };

    this.map = new google.maps.Map(mapDiv, mapOptions);

    // Después de inicializar el mapa, crea el marcador y centra el mapa
    this.marker = new google.maps.Marker({
      position: address.geometry.location,
      map: this.map,
    });
    this.map.setCenter(address.geometry.location);

    this.lat = address.geometry.location.lat();
    this.lon = address.geometry.location.lng();

    // Actualizar formularios con los valores de dirección
    const patch = {
      street: this.street,
      street_number: this.street_number,
      city: this.city,
      province: this.province,
      department: this.department,
      postal_code: this.zipCode,
      lat: this.lat,
      lon: this.lon,
    };
    if (this.stepOneForm) {
      this.stepOneForm.patchValue(patch);
      if (this.stepOneForm.get('sameAddressAsInstallation')?.value) {
        this.copyInstallationAddressToBilling();
      }
    }
    if (this.stepTwoForm) {
      this.stepTwoForm.patchValue(patch);
      if (this.stepTwoForm.get('sameAddressAsInstallation')?.value) {
        this.copyStepTwoAddressToBilling();
      }
    }

    // Obtener el nombre de la calle y otra información detallada
    const streetAddress = address.formatted_address;

    // Limpia los datos anteriores
    this.street = '';
    this.street_number = '';
    this.city = '';
    this.province = '';
    this.department = '';
    this.zipCode = '';

    // Hacer una solicitud de geocodificación inversa para obtener detalles
    /*   const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      { location: address.geometry.location },
      (results, status) => {
        if (status === 'OK' && results.length) {
          // Buscamos primero un resultado exacto de fachada (street_address)
          const result =
            results.find(r => r.types.includes('street_address')) ||
            results[0];
    
          // Ahora parseamos los components como antes
          result.address_components.forEach((component) => {
            const types = component.types;
    
            if (types.includes('route')) {
              this.street = component.long_name;
            }
    
            if (types.includes('street_number')) {
              this.street_number = component.long_name;
            }
    
            if (types.includes('locality')) {
              this.city =
                component.long_name === 'Buenos Aires'
                  ? 'C.A.B.A'
                  : component.long_name;
            }
    
            if (types.includes('administrative_area_level_1')) {
              this.province = component.long_name;
            }
    
            if (types.includes('sublocality_level_1')) {
              this.department = component.long_name;
            }
    
            if (types.includes('postal_code')) {
              this.zipCode = component.long_name;
            }
          });
    
          // Mover marcador y centrar mapa
          if (this.marker) {
            this.marker.setPosition(address.geometry.location);
            this.map.setCenter(address.geometry.location);
          }
        } else {
          console.error(
            'Error al realizar la geocodificación inversa:',
            status
          );
        }
      }
    );*/
    const geocoder = new google.maps.Geocoder();

    // Si 'address' viene de Autocomplete, tiene place_id.
    // Usamos placeId para obtener *exactamente* la dirección seleccionada.
    const request = address.place_id
      ? { placeId: address.place_id }
      : { location: address.geometry.location };

    geocoder.geocode(request, (results, status) => {
      if (status === 'OK' && results[0]) {
        // Con placeId, results[0] es justo el place que seleccionaste
        const result = results[0];

        result.address_components.forEach((component) => {
          const types = component.types;

          if (types.includes('route')) {
            this.street = component.long_name;
          }
          if (types.includes('street_number')) {
            this.street_number = component.long_name; // acá ya será 4679
          }
          if (types.includes('locality')) {
            this.city =
              component.long_name === 'Buenos Aires'
                ? 'C.A.B.A'
                : component.long_name;
          }
          if (types.includes('administrative_area_level_1')) {
            this.province =
              component.long_name === 'Ciudad Autónoma de Buenos Aires'
                ? 'C.A.B.A'
                : component.long_name;
          }
          if (types.includes('sublocality_level_1')) {
            this.department = component.long_name;
          }
          if (types.includes('postal_code')) {
            this.zipCode = component.long_name.replace(/\D/g, '');
          }
        });

        if (this.marker) {
          // movés el marker con la misma geometry que vino del Autocomplete
          this.marker.setPosition(address.geometry.location);
          this.map.setCenter(address.geometry.location);
        }

        // Validar código postal de instalación
        if (this.zipCode) {
          this.validateInstallationZipCode(this.zipCode);
        }
      } else {
        console.error('Error al geocodificar:', status);
      }
    });
  }

  validateInstallationZipCode(zipCode: string): void {
    this.isValidatingZipCode = true;
    this.zipCodeError = '';
    this.isZipCodeValid = false;

    this.landingService
      .checkZipCode(zipCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          this.isValidatingZipCode = false;
          if (response.exists) {
            this.isZipCodeValid = true;
            this.zipCodeError = '';
            // No mostrar alerta cuando es válido, solo el indicador visual
          }
        },
        (error) => {
          this.isValidatingZipCode = false;
          this.isZipCodeValid = false;
          this.zipCodeError =
            'Lo sentimos, el código postal de instalación no está dentro de nuestra área de cobertura.';
          Swal.fire({
            title: 'Código postal no disponible',
            text: 'Lo sentimos, el código postal de instalación no está dentro de nuestra área de cobertura. Por favor, selecciona otra dirección.',
            icon: 'warning',
            confirmButtonColor: '#002968',
            confirmButtonText: 'Entendido',
            customClass: {
              popup: 'swal-wide',
            },
          });

          // Limpiar el formulario de dirección
          if (this.stepOneForm) {
            this.stepOneForm.patchValue({
              street: '',
              street_number: '',
              city: '',
              province: '',
              department: '',
              postal_code: '',
              lat: '',
              lon: '',
            });
          }
          if (this.stepTwoForm) {
            this.stepTwoForm.patchValue({
              street: '',
              street_number: '',
              city: '',
              province: '',
              department: '',
              postal_code: '',
              lat: '',
              lon: '',
            });
          }

          // Ocultar el mapa
          this.viewMap = false;
          this.street = '';
          this.street_number = '';
          this.city = '';
          this.province = '';
          this.department = '';
          this.zipCode = '';
        },
      );
  }

  public handleBillingAddressChange(
    address: Address,
    form: 'stepOne' | 'stepTwo',
  ) {
    // Geocodificar a partir de place_id (cuando está disponible) para precisión
    const geocoder = new google.maps.Geocoder();
    const request = address.place_id
      ? { placeId: address.place_id }
      : { location: address.geometry.location };

    geocoder.geocode(request, (results, status) => {
      if (status === 'OK' && results[0]) {
        const result = results[0];
        let bill_street = '';
        let bill_street_number = '';
        let bill_city = '';
        let bill_province = '';
        let bill_department = '';
        let bill_postal_code = '';

        result.address_components.forEach((component) => {
          const types = component.types;
          if (types.includes('route')) bill_street = component.long_name;
          if (types.includes('street_number'))
            bill_street_number = component.long_name;
          if (types.includes('locality')) {
            bill_city =
              component.long_name === 'Buenos Aires'
                ? 'C.A.B.A'
                : component.long_name;
          }
          if (types.includes('administrative_area_level_1')) {
            bill_province =
              component.long_name === 'Ciudad Autónoma de Buenos Aires'
                ? 'C.A.B.A'
                : component.long_name;
          }
          if (types.includes('sublocality_level_1'))
            bill_department = component.long_name;
          if (types.includes('postal_code'))
            bill_postal_code = component.long_name.replace(/\D/g, '');
        });

        const patch = {
          bill_street,
          bill_street_number,
          bill_city,
          bill_province,
          bill_department,
          bill_postal_code,
        };
        if (form === 'stepOne' && this.stepOneForm) {
          this.stepOneForm.patchValue(patch);
        }
        if (form === 'stepTwo' && this.stepTwoForm) {
          this.stepTwoForm.patchValue(patch);
        }
      } else {
        console.error('Error al geocodificar facturación:', status);
      }
    });
  }

  formatNumber(numeroOriginal: string): string {
    // Convierte el número de cadena a número de punto flotante (float)
    const numero = parseFloat(numeroOriginal);

    // Aplica el formato con tres decimales y usa '.' como separador de miles
    const numeroFormateado = numero.toLocaleString('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return numeroFormateado;
  }

  // Métodos de Mercado Pago - Checkout Links
  setupPaymentMethods(): void {
    if (this.type === 'sub') {
      this.paymentMethods = [
        { value: 'Mercado Pago Sus', label: 'Mercado Pago Suscripción' },
      ];
      // Autoseleccionar el método de pago para suscripciones
      this.stepTwoForm.patchValue({ payment_method: 'Mercado Pago Sus' });
    } else {
      this.paymentMethods = [{ value: 'Mercado Pago', label: 'Mercado Pago' }];
      // Autoseleccionar el método de pago para compras
      this.stepTwoForm.patchValue({ payment_method: 'Mercado Pago' });
    }
  }

  onPaymentMethodChange(value: string): void {
    this.stepTwoForm.patchValue({ payment_method: value });
  }

  viewPass() {
    this.visible = !this.visible;
    this.changeType = !this.changeType;
  }

  ngAfterViewInit(): void {
    // Verificar direcciones después de que la vista esté inicializada
    if (this.step === 2 && this.isLogged) {
      setTimeout(() => {
        this.checkAndRedirectToAddress();
      }, 1000); // Aumentamos el tiempo de espera
    }
  }

  ngAfterViewChecked(): void {
    // Ya no necesitamos renderizar nada aquí con checkout links
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeMode(mode): void {
    this.mode = mode;
    this.errors = null; // Limpiar errores al cambiar de modo
  }

  register(): void {
    if (this.registerForm.invalid) {
      this.scrollToFirstInvalidControl();
      return;
    }
    this.loading = true;
    this.errors = null; // Limpiar errores previos
    const {
      full_name,
      email,
      email_confirmation,
      gender,
      iva_exempt,
      password,
      password_confirmation,
      document,
      phone,
      met_way_id,
      iva_condition,
      payment_condition,
    } = this.registerForm.value;
    var nombre;
    nombre = full_name.toUpperCase();

    var newClient = {
      name: nombre,
      document: document,
      gender: gender,
    };
    var that = this;
    this.veraz(newClient, this.product).then(function () {
      that.landingService
        .registerUser({
          name: nombre,
          email,
          email_confirmation,
          gender,
          iva_exempt,
          password,
          password_confirmation,
          phone,
          document,
          veraz_score: that.veraz_score,
          met_way_id,
          product_id: that.product.id,
          iva_condition,
          payment_condition,
        })
        .pipe(takeUntil(that.destroy$))
        .subscribe(
          (res) => {
            if (!that.checkVeraz) {
              that.router.navigateByUrl('/veraz');
            } else {
              that.sessionService.setTokens(res).then((_) => {
                that.store.dispatch(getUser());
                that.nextStep();
              });
            }
          },
          (err) => {
            that.loading = false; // Detener el loading cuando hay error
            if (err.error.code === 422) {
              that.errors = err.error.error;
            }
          },
        );
    });
  }

  regresar(): void {
    this.step = 1;
  }

  login(): void {
    this.errors = null; // Limpiar errores previos
    const { email, password } = this.loginForm.value;
    this.authService
      .login(email, password)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.sessionService.setTokens(res).then((_) => {
            this.store.dispatch(getUser());
            this.step = 2;
            // Verificar automáticamente si necesita configurar dirección
            setTimeout(() => {
              this.checkAndRedirectToAddress();
            }, 100);
          });
        },
        (err) => {
          if (err.error.code === 422) {
            this.errors = err.error.error;
          } else if (err.status === 401) {
            Swal.fire({
              title: 'Error de autenticación',
              text: 'El email o contraseña son incorrectos.',
              icon: 'error',
              confirmButtonColor: '#002968',
              confirmButtonText: 'Reintentar',
            });
          }
        },
      );
  }

  async nextStep() {
    while (!this.user || !this.user.document) {
      await new Promise((resolve) => setTimeout(resolve, 100)); // espera 100ms
    }
    this.stepTwoForm = this.formBuilder.group({
      street: [this.stepOneForm.value.street, [Validators.required]],
      street_number: [
        this.stepOneForm.value.street_number,
        [Validators.required],
      ],
      department: [this.stepOneForm.value.department, [Validators.required]],
      province: [this.stepOneForm.value.province, [Validators.required]],
      city: [this.stepOneForm.value.city, [Validators.required]],
      lat: [this.stepOneForm.value.lat],
      lon: [this.stepOneForm.value.lon],
      floor: [this.stepOneForm.value.floor],
      postal_code: [this.stepOneForm.value.postal_code, [Validators.required]],
      install_date: [this.stepOneForm.value.install_date],
      observations: [this.stepOneForm.value.observations],
      payment_method: [
        this.type === 'sub' ? 'Mercado Pago Sus' : 'Mercado Pago',
        [Validators.required],
      ],
      codigo_descuento: [this.stepOneForm.value.codigo_descuento],
      billing_city: [this.stepOneForm.value.bill_city],
      billing_department: [this.stepOneForm.value.bill_department],
      billing_floor: [this.stepOneForm.value.bill_floor],
      billing_province: [this.stepOneForm.value.bill_province],
      billing_street: [this.stepOneForm.value.bill_street],
      billing_street_number: [this.stepOneForm.value.bill_street_number],
      billing_postal_code: [this.stepOneForm.value.bill_postal_code],
      sameAddressAsInstallation: [
        this.stepOneForm.value.sameAddressAsInstallation,
      ],
    });

    //diego: 14/03/2024 => forzar checkVeraz devolver true si es venta
    if (this.type === 'sale') {
      this.loading = false;
      this.step = 2;
      // Verificar automáticamente si necesita configurar dirección
      setTimeout(() => {
        this.checkAndRedirectToAddress();
      }, 100);
      return (this.checkVeraz = true);
    }

    var data = {
      product_type_id: this.product.product_type_id,
      client_document: this.user.document,
      client_id: this.user.id,
    };

    await this.landingService.getScore(data).then(
      (res) => {
        if (res && res.approved != null) {
          this.checkVeraz = res.approved;
          if (res.score) {
            this.veraz_score = res.score;
          }
        } else {
          this.checkVeraz = false;
        }
        return this.checkVeraz;
      },
      (err) => {
        this.checkVeraz = false;
        console.log('err', err);
        return this.checkVeraz;
      },
    );

    if (!this.checkVeraz) {
      this.router.navigateByUrl('/veraz');
      this.loading = false;
    }
    this.loading = false;
    this.step = 2;
  }

  // Función auxiliar para mostrar mensajes de éxito
  private showSuccessMessage(message: string): void {
    Swal.fire({
      title: '¡Éxito!',
      text: message,
      icon: 'success',
      confirmButtonColor: '#002968',
      confirmButtonText: 'Continuar',
      timer: 3000,
      timerProgressBar: true,
    });
  }

  // Método para manejar éxito en el procesamiento de pagos
  private handlePaymentSuccess(): void {
    this.clearPaymentStates();
    this.loading = false;
    // Limpiar cupón del localStorage al completar la compra
    localStorage.removeItem('appliedCoupon');
  }

  // Método para manejar errores en el procesamiento de pagos
  private handlePaymentError(errorMessage: string): void {
    this.clearPaymentStates();
    this.loading = false;
    this.hasPaymentError = true;
    this.paymentError = errorMessage;

    Swal.fire({
      title: 'Error en el pago',
      text: errorMessage,
      icon: 'error',
      confirmButtonColor: '#002968',
      confirmButtonText: 'Reintentar',
      customClass: {
        popup: 'swal-wide',
      },
    });
  }

  // Método para reintentar el pago (limpiar estados y permitir nuevo intento)
  retryPayment(): void {
    this.clearPaymentStates();
  }

  // Método unificado para procesar compras y suscripciones
  processPayment(): void {
    // Limpiar estados anteriores
    this.clearPaymentStates();

    this.loading = true;

    // Para suscripciones, mostrar mensaje informativo sobre redirección
    if (
      this.type === 'sub' &&
      this.stepTwoForm.get('payment_method')?.value === 'Mercado Pago Sus'
    ) {
      Swal.fire({
        title: 'Redirigiendo...',
        text: 'Será redirigido al checkout de Mercado Pago para completar la suscripción',
        icon: 'info',
        confirmButtonColor: '#002968',
        confirmButtonText: 'Entendido',
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
      });

      // Procesar la suscripción que generará el checkout link
      this.purchase();
    } else {
      // Para compras normales, proceder normalmente
      this.purchase();
    }
  }

  // Método para limpiar estados de pago
  private clearPaymentStates(): void {
    this.hasPaymentError = false;
    this.paymentError = '';
    this.isRedirecting = false;
    this.checkoutUrl = '';
  }

  purchase(): void {
    this.loading = true;
    console.log('stepTwoForm valur in purchase', this.stepTwoForm.value);
    const customThis = this;
    let quantity: string = this.quantity;
    let periodicity: number = this.periodicity.id;
    let LogisticCompanyId: null | number = null;
    let paymentMethod: string;
    if (!this.stepTwoForm.get('payment_method').value) {
      const paymentMethod =
        this.type === 'sub' ? 'Mercado Pago Sus' : 'Mercado Pago';
      this.stepTwoForm.patchValue({ payment_method: paymentMethod });
    }

    this.product.periodicity.forEach((p) => {
      if (p.years === 0 && p.months === 0 && p.days === 0) {
        periodicity = p.id;
      }
    });

    // 10-04-2025 => DIEGO HARDCODED ID SHIPNOW
    if (this.stepTwoForm.get('payment_method').value == 'Mercado Pago') {
      LogisticCompanyId = 3;
    }

    const {
      street,
      street_number,
      department,
      province,
      city,
      lat,
      lon,
      floor,
      postal_code,
      install_date,
      codigo_descuento,
      observations,
      payment_method,
      billing_city,
      billing_department,
      billing_floor,
      billing_province,
      billing_street,
      billing_street_number,
      billing_postal_code,
      sameAddressAsInstallation,
    } = this.stepTwoForm.value;

    this.veraz(this.user, this.product).then(function () {
      if (!customThis.checkVeraz) {
        customThis.router.navigateByUrl('/veraz');
      } else {
        customThis.landingService
          .requestSubscription({
            street,
            number: street_number,
            department: department,
            province,
            city,
            lat,
            lon,
            floor,
            postal_code,
            install_date,
            codigo_descuento,
            discount_id: customThis.couponDiscount?.id,
            observations,
            payment_method,
            periodicity_id: periodicity,
            product_id: customThis.product.id,
            veraz_score: customThis.veraz_score,
            billing_city,
            billing_department,
            billing_floor,
            billing_province,
            billing_street,
            billing_postal_code,
            billing_street_number,
            sameAddressAsInstallation,
            quantity,
            logistic_company_id: LogisticCompanyId,
          })
          .pipe(takeUntil(customThis.destroy$))
          .subscribe(
            (res) => {
              customThis.loading = false;
              console.log('Respuesta del API:', res);

              // Verificar si es una respuesta exitosa de suscripción con Mercado Pago
              if (
                res &&
                res['mercado_pago'] &&
                res['mercado_pago']['status'] === 'success'
              ) {
                console.log(
                  '✅ Suscripción de MercadoPago creada exitosamente!',
                );
                console.log('Plan ID:', res['mercado_pago']['plan_id']);
                console.log(
                  'Suscripción ID:',
                  res['mercado_pago']['subscription_id'],
                );
                console.log('Mensaje:', res['mercado_pago']['message']);

                // Mostrar mensaje de éxito
                // Para suscripciones con Mercado Pago - checkout link
                if (res['mercado_pago']['checkout_link']) {
                  customThis.showSuccessMessage(
                    'Suscripción preparada. Redirigiendo al checkout...',
                  );

                  // Mostrar estado de redirección
                  customThis.isRedirecting = true;
                  customThis.checkoutUrl = res['mercado_pago']['checkout_link'];

                  // Redirigir al checkout de Mercado Pago
                  setTimeout(() => {
                    window.location.href = res['mercado_pago']['checkout_link'];
                  }, 2000);
                } else {
                  // Método legacy de suscripciones (ya no debería usarse)
                  customThis.showSuccessMessage(
                    res['mercado_pago']['message'] ||
                      'Suscripción creada exitosamente',
                  );

                  customThis.handlePaymentSuccess();

                  setTimeout(() => {
                    customThis.router.navigate(['/purchase-thanks'], {
                      queryParams: {
                        type: 'subscription',
                        method: 'mercado_pago',
                        planId: res['mercado_pago']['plan_id'],
                        subscriptionId: res['mercado_pago']['subscription_id'],
                      },
                    });
                  }, 2000);
                }
              } else if (res && res['checkout_link']) {
                // Para cualquier otro caso que requiera redirección con checkout
                customThis.isRedirecting = true;
                customThis.checkoutUrl = res['checkout_link'];
                window.location.href = res['checkout_link'];
              } else {
                // Respuesta exitosa sin casos específicos (compra regular)
                customThis.showSuccessMessage(
                  'Procesamiento completado exitosamente',
                );

                // Limpiar estados de pago exitosamente
                customThis.handlePaymentSuccess();

                // Redirigir a página de agradecimiento para compra regular
                setTimeout(() => {
                  customThis.router.navigate(['/purchase-thanks'], {
                    queryParams: {
                      type: 'purchase',
                      method:
                        customThis.stepTwoForm.get('payment_method')?.value ||
                        'unknown',
                    },
                  });
                }, 2000);
              }
            },
            (error) => {
              // Verificar si es el error específico de método de pago no permitido
              if (
                error &&
                error.error &&
                error.error.type === 'non_critical' &&
                error.error.cause === 'missing_payment_information' &&
                error.error.message === 'payment_method_not_in_allowed_types'
              ) {
                customThis.loading = false;

                // Mostrar alert específico
                alert(
                  'El método de pago seleccionado no está permitido. Se ha cambiado automáticamente a Tarjeta de Crédito.',
                );

                // Para suscripciones, cambiar el método de pago a Mercado Pago
                customThis.paymentMethods = [
                  {
                    value: 'Mercado Pago Sus',
                    label: 'Mercado Pago Suscripción',
                    disabled: true,
                  },
                ];
                customThis.stepTwoForm.patchValue({
                  payment_method: 'Mercado Pago Sus',
                });
                customThis.isPaymentMethodDisabled = true;
              } else {
                // Usar el nuevo método para manejar errores
                let errorMessage =
                  'Ocurrió un error inesperado al procesar el pago.';

                if (error && error.error && error.error.message) {
                  errorMessage = error.error.message;
                } else if (error && error.message) {
                  errorMessage = error.message;
                }

                customThis.handlePaymentError(errorMessage);
              }
            },
          );
      }
    });
  }

  async veraz(client, product, force = false) {
    console.log('client, product', client, product);

    var data = {
      client_name: client.name,
      client_document: client.document,
      client_gender: client.gender,
      product_type_id: product.product_type_id,
    };

    if (this.isLogged) {
      data['client_id'] = this.user.id ? this.user.id : 0;
    }

    if (this.checkVeraz == null || force == true) {
      await this.landingService.verifyScore(data).then(
        (res) => {
          console.log('respuesta veraz', res);

          // Obtener el nombre y el apellido del primer solicitante
          const solicitante = res.response.applicants[0];
          const nombreCompleto =
            solicitante.SMARTS_RESPONSE.variablesDeEntrada.nombre;
          let fullName = '';
          fullName = nombreCompleto.trim();

          // Asignar los valores a los inputs
          this.registerForm.patchValue({
            full_name: fullName,
          });
          //diego: 14/03/2024 => forzar checkVeraz devolver true si es venta
          if (this.type === 'sale') {
            return (this.checkVeraz = true);
          }

          if (res && res.approved != null) {
            this.checkVeraz = res.approved;
            if (res.score) {
              this.veraz_score = res.score;
            }
          } else {
            this.checkVeraz = false;
          }
          return this.checkVeraz;
        },
        (err) => {
          this.checkVeraz = false;
          console.log('err', err);
          return this.checkVeraz;
        },
      );
    } else {
      return true;
    }
  }

  onDocumentBlur(event: any): void {
    this.checkVeraz = null;
    this.registerForm.get('first_name')?.setValue('');
    this.registerForm.get('last_name')?.setValue('');
    const documentControl = this.registerForm.get('document');
    if (documentControl?.valid) {
      const client = {
        name: this.registerForm.get('first_name')?.value,
        document: event.target.value,
        gender: this.registerForm.get('gender')?.value,
      };
      const product = {
        product_type_id: this.product.product_type_id,
      };
      console.log(this.product.product_type_id);
      this.loading = true; // Iniciar el loading
      this.veraz(client, product).finally(() => {
        this.loading = false; // Detener el loading
      });
    }
  }

  getSalePrice(
    product: IProduct,
    periodicityMonths: number,
  ): {
    price: number;
    cost: number;
    percentage: number;
  } | null {
    if (!product.periodicity || product.periodicity.length === 0) {
      return null;
    }

    const periodicity = product.periodicity.find(
      (p: any) => p.months === periodicityMonths,
    );
    if (periodicity) {
      return {
        price: periodicity.pivot.periodic_price,
        cost: periodicity.pivot.price,
        percentage: 40,
      };
    }
  }

  calculateInterestFreeInstallments(
    price: number,
    installments: number = 6,
  ): string {
    if (!price || price <= 0 || !installments || installments <= 0) {
      return '0';
    }
    const installmentAmount = price / installments;
    return this.formatNumber(installmentAmount.toString());
  }

  preventNegativeInput(event: any): void {
    const value = event.target.value;
    if (value <= 0) {
      event.target.value = '';
      this.registerForm.get('document')?.setValue('');
    }
  }

  onlyNumbers(event: any): void {
    const value = event.target.value;
    // Eliminar cualquier carácter que no sea número
    const numericValue = value.replace(/[^0-9]/g, '');
    event.target.value = numericValue;
    // Actualizar el valor en el formulario
    if (this.registerForm.get('phone')) {
      this.registerForm.get('phone')?.setValue(numericValue);
    }
    if (this.updateUserForm.get('phone')) {
      this.updateUserForm.get('phone')?.setValue(numericValue);
    }
  }

  private apiUrl = environment.apiUrl;

  async updateUser() {
    const newUserData = this.updateUserForm.value;
    this.userData = newUserData;

    if (this.updateUserForm.valid) {
      this.loading = true;

      const formData = this.updateUserForm.value;
      const fullName = this.empresaSelect
        ? formData.first_name
        : `${formData.last_name.toUpperCase()}, ${formData.first_name.toUpperCase()}`;

      formData.person_type === 'after' ? 'PERSONA FISICA' : 'EMPRESA';

      let dataToUpdate: any = {
        name: fullName,
        document: formData.document,
        phone: formData.phone,
        gender: formData.gender,
        iva_exempt: formData.iva_exempt,
        person_type: formData.person_type,
        password: formData.password,
      };

      this.sessionService.getToken().then((authToken) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
        });

        this.landingService
          .updateUser(this.user.id, formData, this.empresaSelect)
          .subscribe(
            (response) => {
              this.loading = false;
              this.step = 2;
            },
            (error) => {
              console.error(error);
              this.loading = false;
            },
          );
      });
      await this.veraz(dataToUpdate, this.product, true).then(function () {});

      if (!this.checkVeraz) {
        this.router.navigateByUrl('/veraz');
      }
    } else {
      console.log('Datos incompletos y/o invalidos en el formulario.');
    }
  }

  scrollToFirstInvalidControl() {
    setTimeout(() => {
      for (const key of Object.keys(this.registerForm.controls)) {
        if (this.registerForm.controls[key].invalid) {
          const invalidControl = document.getElementById(key);
          if (invalidControl) {
            invalidControl.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
            return; // Sale del bucle después de encontrar el primer control inválido
          }
        }
      }
    }, 0);
  }

  discount = '';
  // Propiedades para cupones de descuento
  couponCode: string = '';
  couponDiscount: any = null;
  couponProducts: IProduct[] = [];
  couponError: string = '';
  couponLoading: boolean = false;
  isCouponValid: boolean = false;
  getPrice(product: IProduct): {
    original_price: number;
    price: number;
    periodicity: string;
    original_cost: number;
    cost: number;
    periodicity_label: string;
  } | null {
    if (!product.periodicity || product.periodicity.length === 0) {
      return null;
    }

    if (
      product.periodicity &&
      product.periodicity.length > 0 &&
      this.type === 'sale'
    ) {
      let installation: number = 0;
      let periodicPrice: number = 0;
      let periodicPriceMultiplied: number = 0;
      this.serviceName = 'Venta';
      product.periodicity.forEach((periodicity) => {
        if (
          periodicity &&
          periodicity.years === 0 &&
          periodicity.months === 0 &&
          periodicity.days === 0
        ) {
          installation = periodicity.pivot.price;
          periodicPrice = periodicity.pivot.periodic_price;
          if (this.quantity) {
            periodicPriceMultiplied =
              periodicPrice * parseFloat(this.quantity.toString());
            this.total =
              parseFloat(installation.toString()) +
              parseFloat(periodicPriceMultiplied.toString());
          }
        }
      });
      return {
        original_price: product.periodicity[0].pivot.periodic_price,
        price: periodicPrice,
        cost: installation,
        original_cost: product.periodicity[0].pivot.price,
        periodicity: `por ${product.periodicity[0].months} meses`,
        periodicity_label: '',
      };
    }

    const monthly = product.periodicity.find((item) => item.months >= 1);
    const discount = this.discount;

    if (monthly) {
      let price: number;
      let cost: number;
      let periodicity_label: string = '';

      // Caso especial: Cupón AGUATODOELDIA
      if (
        this.isCouponValid &&
        this.couponDiscount &&
        this.couponDiscount.code === 'AGUATODOELDIA'
      ) {
        // Usar internal_price para el precio mensual (reemplaza periodic_price)
        price =
          monthly.pivot.internal_price !== undefined &&
          monthly.pivot.internal_price !== null
            ? parseFloat(monthly.pivot.internal_price.toString())
            : monthly.pivot.periodic_price;

        // El costo de instalación debe ser 0 (gratis) o el valor que venga
        cost =
          monthly.pivot.discounted_price !== undefined &&
          monthly.pivot.discounted_price !== null
            ? monthly.pivot.discounted_price
            : monthly.pivot.price;
      } else {
        // Usar precio con descuento si está disponible (otros cupones)
        price =
          monthly.pivot.discounted_periodic_price !== undefined &&
          monthly.pivot.discounted_periodic_price !== null &&
          monthly.pivot.discounted_periodic_price > 0
            ? monthly.pivot.discounted_periodic_price
            : monthly.pivot.periodic_price;

        cost =
          monthly.pivot.discounted_price !== undefined &&
          monthly.pivot.discounted_price !== null
            ? monthly.pivot.discounted_price
            : monthly.pivot.price;

        // Si no hay discounted_periodic_price pero hay cupón válido, calcular descuento
        if (
          this.isCouponValid &&
          this.couponDiscount &&
          (!monthly.pivot.discounted_periodic_price ||
            monthly.pivot.discounted_periodic_price === 0)
        ) {
          const basePrice = parseFloat(monthly.pivot.periodic_price.toString());
          const baseCost = parseFloat(monthly.pivot.price.toString());

          if (this.couponDiscount.operation === '%') {
            const discountPercent = parseFloat(
              this.couponDiscount.amount.toString(),
            );
            price = basePrice * (1 - discountPercent / 100);
            periodicity_label = `por ${this.couponDiscount.months} meses`;
          }

          if (
            this.couponDiscount.install_operation === '%' &&
            this.couponDiscount.install_discount
          ) {
            const installDiscountPercent = parseFloat(
              this.couponDiscount.install_discount.toString(),
            );
            cost = baseCost * (1 - installDiscountPercent / 100);
          }
        }
      }

      this.isSubsText = 'x mes';
      this.serviceName = 'Mensual';

      // Aplicar descuentos especiales de código promocional
      if (discount === 'CYBERFIL50') {
        price = parseFloat(monthly.pivot.periodic_price.toString()) * 0.5;
        cost = 0;
        periodicity_label = 'en tu primer mes';
      } else if (discount === 'CYBERFIL20') {
        price = parseFloat(monthly.pivot.periodic_price.toString()) * 0.8;
        cost = 0;
        periodicity_label = 'en tus primeros 3 meses';
      }

      if (monthly.months === 1) {
        return {
          original_price: monthly.pivot.periodic_price,
          price: price,
          cost: cost,
          original_cost: monthly.pivot.price,
          periodicity: 'x mes',
          periodicity_label: periodicity_label,
        };
      } else {
        switch (monthly.months) {
          case 2: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: 'por bimestre',
              periodicity_label: periodicity_label,
            };
          }
          case 3: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: 'por trimestre',
              periodicity_label: periodicity_label,
            };
          }
          case 4: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: 'por cuatrimestre',
              periodicity_label: periodicity_label,
            };
          }
          case 6: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: 'por semestre',
              periodicity_label: periodicity_label,
            };
          }
          default: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: `por ${monthly.months} meses`,
              periodicity_label: '',
            };
          }
        }
      }
    }
  }

  updateData(type: string) {
    this.step = 1;
    this.updateDataType = type;

    // Cuando se edita la dirección, rellenar el formulario con los datos del usuario
    if (
      type === 'direction' &&
      this.user?.addresses &&
      this.user.addresses[0]
    ) {
      const userAddress = this.user.addresses[0];
      const fullAddress = userAddress.address;

      // Parsear la dirección completa para separar calle y número
      const match = fullAddress?.match(
        /^(.+?)\s+(\d{1,5}(?:\s?[A-Za-z]{0,4})?)$/,
      );

      let street = '';
      let street_number = '';

      if (match) {
        street = match[1].trim();
        street_number = match[2].trim();
      } else {
        // Si no se puede parsear, usar la dirección completa como calle
        street = fullAddress || '';
      }

      // Actualizar variables locales para los ngModel
      this.street = street;
      this.street_number = street_number;
      this.city = userAddress.city || '';
      this.province = userAddress.province || '';
      this.department = userAddress.department || '';
      this.zipCode = userAddress.postal_code || '';

      // Rellenar el formulario stepTwoForm con TODOS los datos del usuario
      this.stepTwoForm.patchValue({
        street: street,
        street_number: street_number,
        city: userAddress.city,
        province: userAddress.province,
        department: userAddress.department,
        postal_code: userAddress.postal_code,
        floor: userAddress.floor || '',
        lat: userAddress.lat,
        lon: userAddress.lon,
        observations: userAddress.observations || '',
      });

      // Validar automáticamente el código postal si existe
      if (userAddress.postal_code) {
        this.validateInstallationZipCode(userAddress.postal_code.toString());
      } else {
        this.isValidatingZipCode = false;
        this.zipCodeError = '';
        this.isZipCodeValid = false;
      }
    } else if (type === 'direction') {
      // Si no hay dirección del usuario, resetear estado de validación
      this.isValidatingZipCode = false;
      this.zipCodeError = '';
      this.isZipCodeValid = false;
    }
  }

  checkAndRedirectToAddress() {
    // Verificar que los formularios estén inicializados
    if (!this.stepTwoForm) {
      return false;
    }

    // Verificar si no hay dirección configurada
    const hasFormAddress =
      this.stepTwoForm?.value?.street &&
      this.stepTwoForm?.value?.street.trim() !== '';
    const hasUserAddress =
      this.user?.addresses &&
      this.user.addresses[0]?.address &&
      this.user.addresses[0].address.trim() !== '';

    if (
      !hasFormAddress &&
      !hasUserAddress &&
      this.step === 2 &&
      this.isLogged
    ) {
      // Automáticamente redirigir a configurar dirección
      console.log(
        'No hay dirección configurada, redirigiendo a configurar dirección...',
      );
      this.updateData('direction');
      return true;
    }
    return false;
  }

  handleCancelButton() {
    if (!this.user?.addresses || !this.user.addresses[0]) {
      this.stepTwoForm.reset();
      return;
    }

    const userAddress = this.user.addresses[0];
    const fullAddress = userAddress.address;

    const match = fullAddress?.match(
      /^(.+?)\s+(\d{1,5}(?:\s?[A-Za-z]{0,4})?)$/,
    );

    let street = '';
    let street_number = '';

    if (match) {
      street = match[1].trim();
      street_number = match[2].trim();
    } else {
      street = fullAddress || '';
    }

    // Actualizar variables locales
    this.street = street;
    this.street_number = street_number;
    this.city = userAddress.city || '';
    this.province = userAddress.province || '';
    this.department = userAddress.department || '';
    this.zipCode = userAddress.postal_code || '';

    // Restaurar TODOS los datos del usuario en el formulario
    this.stepTwoForm.patchValue({
      street: street,
      street_number: street_number,
      city: userAddress.city,
      province: userAddress.province,
      department: userAddress.department,
      postal_code: userAddress.postal_code,
      floor: userAddress.floor || '',
      lat: userAddress.lat,
      lon: userAddress.lon,
      observations: userAddress.observations || '',
    });

    // Validar automáticamente el código postal del usuario al cancelar
    if (userAddress.postal_code) {
      this.validateInstallationZipCode(userAddress.postal_code.toString());
    } else {
      // Solo resetear si no hay código postal para validar
      this.isValidatingZipCode = false;
      this.zipCodeError = '';
      this.isZipCodeValid = false;
    }
  }

  // Métodos para cupones de descuento
  validateCoupon(): void {
    if (!this.couponCode || this.couponCode.trim() === '') {
      Swal.fire({
        title: 'Cupón requerido',
        text: 'Por favor, ingresa un código de cupón',
        icon: 'warning',
        confirmButtonColor: '#002968',
        confirmButtonText: 'Entendido',
      });
      return;
    }

    this.store.dispatch(
      fromLanding.validateCoupon({ code: this.couponCode.trim() }),
    );
  }

  clearCoupon(): void {
    this.couponCode = '';
    this.store.dispatch(fromLanding.clearCoupon());
    // Limpiar del localStorage
    localStorage.removeItem('appliedCoupon');
    // Recargar el producto sin descuento
    this.store.dispatch(
      fromLanding.getProduct({
        id: this.product.id,
        zipCode: this.zip_code,
        periodicity: this.plan,
      }),
    );
  }

  updateProductWithDiscount(): void {
    if (!this.product) {
      return;
    }

    if (this.couponProducts && this.couponProducts.length > 0) {
      // Buscar el producto actual en los productos con descuento
      const productWithDiscount = this.couponProducts.find(
        (p) => p.id === this.product.id,
      );

      if (productWithDiscount) {
        // Actualizar el producto con los precios con descuento
        this.product = JSON.parse(JSON.stringify(productWithDiscount));
        this.product.imageUrl = this.product?.galeries[0]?.file_name;
        this.periodicity = this.product.periodicity
          ? this.product.periodicity[0]
          : null;

        if (this.periodicity && this.periodicity.pivot) {
          // Usar los precios con descuento si están disponibles
          const installPrice =
            this.periodicity.pivot.discounted_price ||
            this.periodicity.pivot.price;
          const periodicPrice =
            this.periodicity.pivot.discounted_periodic_price ||
            this.periodicity.pivot.periodic_price;

          this.total =
            parseFloat(installPrice.toString()) +
            parseFloat(periodicPrice.toString());
        }

        Swal.fire({
          title: '¡Cupón aplicado!',
          text: 'El descuento se ha aplicado correctamente',
          icon: 'success',
          confirmButtonColor: '#002968',
          confirmButtonText: 'Continuar',
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
        });

        // Validar el código postal si existe en el formulario después de aplicar el cupón
        const postalCode =
          this.stepOneForm?.get('postal_code')?.value ||
          this.stepTwoForm?.get('postal_code')?.value;
        if (postalCode && !this.isZipCodeValid) {
          this.validateInstallationZipCode(postalCode.toString());
        }
      }
    }
  }

  loadSavedCoupon(): void {
    const savedCoupon = localStorage.getItem('appliedCoupon');
    if (savedCoupon) {
      try {
        const couponData = JSON.parse(savedCoupon);
        this.couponCode = couponData.code;
        // Revalidar el cupón para obtener los precios actualizados
        if (this.couponCode) {
          this.store.dispatch(
            fromLanding.validateCoupon({ code: this.couponCode }),
          );
        }
      } catch (error) {
        console.error('Error al cargar cupón guardado:', error);
        localStorage.removeItem('appliedCoupon');
      }
    }
  }
}

function lengthValidator(minLength: number, maxLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const length = control.value?.toString().length;
    return length >= minLength && length <= maxLength
      ? null
      : { lengthRange: { value: control.value } };
  };
}
